import { SetHeaderService } from "@/helper/userHelper";
import service from "../baseHttpService";

class JournalService {
  DoGetJournalViewDetailList(journalIdList: Array<number>) {
    const _input = {
      journalIdList: journalIdList,
    };

    return service.peakExportAPI
      .post("/api/Journal/GetJournalViewDetailList", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
}

export default new JournalService();
